import GcmCartPhoto from "@/containers/Participant/GcmShared/GcmCartPhoto";
import GiftCardImage from "@/shared/components/GiftCardImage";

export const CART_COLUMNS = [
  {
    Header: "merchant",
    accessor: "logo",
    // GCM rows pass the business (photo + Yelp rating); other merchants pass a logo URL
    Cell: ({ value }) => (value && typeof value === "object"
      ? <GcmCartPhoto business={value} />
      : <GiftCardImage src={value} alt="logo" className="rounded-3" />),
  },
  {
    Header: "",
    accessor: "name",
  },
  {
    Header: "gift_code_value",
    accessor: "giftCode",
  },
  {
    Header: "quantity",
    accessor: "quantity",
  },
  {
    Header: "unit_price",
    accessor: "price",
    Cell: ({ row, value }) => {
      return `${Math.floor(value)}`;
    },
  },
  {
    Header: "total",
    accessor: "total",
    Cell: ({ row, value }) => {
      return `${Math.floor(value).toLocaleString()}`;
    },
  },
];

// Row labels for the stacked mobile table: the photo/logo gets a centered row of its own and
// the "Merchant" label moves to the name, so label and merchant line up
export const cartCellLabel = (column, t) => {
  if (column.id === "logo") return "";
  if (column.id === "name") return t("merchant");
  return typeof column.Header === "string" ? t(column.Header) : "";
};
